import { createContext, useContext } from 'react';

import { getRevenueTypeContextDimension } from '@/helpers/job-posting-revenue-type';

import { XingApplicationJob } from '../types';

export const JobApplicationRevenueTypeContext = createContext<XingApplicationJob | undefined>(undefined);

export const useJobPostingRevenueType = (): string => {
  const job = useContext(JobApplicationRevenueTypeContext);

  if (typeof job === 'undefined') {
    throw new Error('useJobPostingRevenueType must be used within an initialized JobApplicationRevenueTypeContext');
  }

  return getRevenueTypeContextDimension(job);
};
